<script>
	import cn from 'classnames';
	import tyre from '$lib/images/pneumatiky/tyre.png';
	import Heading from './Heading.svelte';
	import ChevronDown from '$lib/images/svg/chevron-down.svelte';
	import { goto } from '$app/navigation';

	export let data;

	let selectedWidth = data?.width ?? '';
	let selectedAspectRatio = data?.aspectRatio ?? '';
	let selectedRimSize = data?.rimSize ?? '';

	function composeUrl() {
		let url = '/univerzalni-dily/pneumatiky?';
		let isFirst = true;
		if (selectedWidth != '') {
			if (!isFirst) {
				url += '&';
			} else {
				isFirst = false;
			}

			url += 'width=' + selectedWidth;
		}
		if (selectedAspectRatio != '') {
			if (!isFirst) {
				url += '&';
			} else {
				isFirst = false;
			}
			url += 'aspect_ratio=' + selectedAspectRatio;
		}
		if (selectedRimSize != '') {
			if (!isFirst) {
				url += '&';
			} else {
				isFirst = false;
			}
			url += 'rim_size=' + selectedRimSize;
		}
		return url;
	}

	function selectFce() {
		console.log(selectedWidth);
		console.log('test');
		//change location params in url
		// get query param width
		const url = composeUrl();
		// navigate to
		
		//goto(url.replace("/univerzalni-dily/pneumatiky", ""), { replaceState: true });
		window.location.href = composeUrl();
	}

	const selectCls = 'border-2 border-gray-geyser px-4 py-1 md:py-2';
</script>

<div class="mt-5 border border-gray-geyser p-3 shadow-sm md:mt-6 md:p-6 md:shadow-md">
	<Heading tag="strong" class="mx-auto mb-4 text-center text-2xl">Vyber správnou pneumatiku</Heading
	>
	<div class="mt-1 flex flex-wrap items-center">
		<img src={tyre} alt="Pneu" class="mx-auto w-[70%]" />

		<div class="grid w-full grid-cols-3 gap-x-2">
			<select id="width" class={cn(selectCls)} bind:value={selectedWidth} on:change={selectFce}>
				<option value="">Šířka</option>
				{#if data?.dimension?.width != null}
					{#each data?.dimension?.width as width}
						<option value={width.toString()}>{width}</option>
					{/each}
				{/if}
			</select>

			<select
				id="profile"
				class={cn(selectCls)}
				bind:value={selectedAspectRatio}
				on:change={selectFce}
			>
				<option value="">Boční profil</option>
				{#if data?.dimension.aspect_ratio != null}
					{#each data?.dimension?.aspect_ratio as width}
						<option value={width.toString()}>{width}</option>
					{/each}
				{/if}
			</select>

			<select
				id="diameter"
				class={cn(selectCls)}
				bind:value={selectedRimSize}
				on:change={selectFce}
			>
				<option value="">Průměr</option>
				{#if data?.dimension.rim_size != null}
					{#each data?.dimension?.rim_size as width}
						<option value={width.toString()}>{width}</option>
					{/each}
				{/if}
			</select>
		</div>
	</div>
</div>
